<template>
    <svg id="Lager_1" data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 11.6999998 11.6999998">
        <circle class="cls-1" cx="5.8499999" cy="3.3460082" r="3.1993154"/>
        <path class="cls-1" d="M.1462829,11.553307v-.9807728c0-1.2780926,1.0360988-2.3141914,2.3141914-2.3141914h6.7790512c1.2780926,0,2.3141914,1.0360988,2.3141914,2.3141914v.9807728"/>
    </svg>
</template>
<style scoped>
.cls-1 {
    fill: none;
    stroke: #000;
    stroke-linejoin: round;
    stroke-width: .25px;
}
</style>
